'use client';
import { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { useActiveLab } from '@witmetrics/data-store';
import { usePath } from '@/hooks/usePath';
import { PAGES } from '@/constants/pages';
import CaseCreationCard from '@/components/CaseCreationCard';
import TasksCard from './TasksCard';
import ProjectsCard from './ProjectsCard';
import { COLUMN_SPACING, ROW_SPACING } from './constants';
import { classes } from './utils';

export default function Page() {
  const { navigate } = usePath();
  const activeLab = useActiveLab();

  useEffect(() => {
    // You're on the wrong dashboard...
    if (activeLab) return navigate(PAGES.LAB_DASHBOARD);
  }, [activeLab]);

  return (
    <div className={classes.wrapper}>
      <Grid
        container
        className={classes.grid}
        rowSpacing={ROW_SPACING}
        columnSpacing={COLUMN_SPACING}>
        <Grid item xs={12}>
          <CaseCreationCard condensed />
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            rowSpacing={ROW_SPACING}
            columnSpacing={COLUMN_SPACING}>
            <Grid item xs={12}>
              <Grid
                container
                rowSpacing={ROW_SPACING}
                columnSpacing={COLUMN_SPACING}>
                <Grid item xs={12} md={6}>
                  <ProjectsCard />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TasksCard />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
